export default __webpack_public_path__ + "static/media/edit-gray.8a0e9125.svg";